import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from "@angular/common";
import { Decimal } from "decimal.js/decimal";

@Pipe( {
    name: 'point'
} )
export class PointPipe implements PipeTransform {
    constructor( private decimalPipe: DecimalPipe ) { }

    transform( value: any, showUnit: boolean = false, showEmtpy: boolean = true ): any {
        const castValue = ( value instanceof Decimal ) ? value.toNumber() : value;
        if ( !showEmtpy && castValue == 0 ) {
            return 'Non disponible';
        } else {
            let result = this.decimalPipe.transform(( value instanceof Decimal ) ? value.toNumber() : value, '1.2-2' );
            if ( showUnit ) {
                return result + ' pts';
            }
            else {
                return result;
            }
        }
    }

}
